import { User } from 'src/app/shared/models/user/User';
import { LoginTypes, LogoutTypes, UserActionTypes } from '../../actions/user/user.actions';
import { AppState } from 'src/app/app.state';
import { ACCESS_TOKEN } from 'src/constants/local-storage-variables';
import { IResponseMessage } from 'src/app/shared/models/response-message/IResponseMessage';

export interface UserState {
  accessToken: string;
  authenticated: boolean;
  user?: User;
  error?: IResponseMessage;
  loaded: boolean;
  loading: boolean;
}

const initialState: UserState = {
  accessToken: null,
  authenticated: false,
  user: null,
  loaded: false,
  loading: false
};

export function userReducer(state: UserState = initialState, action: any): UserState {
  switch (action.type) {
    case LoginTypes.LOGIN:
      return Object.assign({}, state, {
        loading: true
      });

    case LoginTypes.LOGIN_ERROR:
      return Object.assign({}, state, {
        authenticated: false,
        error: action.error,
        loaded: true,
        loading: false
      });

    case LoginTypes.LOGIN_SUCCESS:
      return Object.assign({}, state, {
        accessToken: action.user.accessToken,
        authenticated: action.authenticated,
        user: action.user,
        loading: false
      });

    case LogoutTypes.LOGOUT_SUCCESS:
      return { ...initialState };

    case UserActionTypes.GET_CURRENT_USER_SUCCESS:
      return {
        ...state,
        user: { ...state.user, ...action.user }
      };
    default:
      return state;
  }
}

export const getUserState = (state: AppState) => state.user;
export const getCurrentUser = (state: UserState) => state.user;

export const isAuthenticated = (state: UserState) => {
  const tokenFromLocalStorage: string = localStorage.getItem(ACCESS_TOKEN);
  return !!tokenFromLocalStorage ? true : state.authenticated;
};

export const getAuthenticationError = (state: UserState) => state.error;
export const getAuthenticationLoading = (state: UserState) => state.loading;

export const getAuthToken = (state: UserState) => {
  const tokenFromLocalStorage: string = localStorage.getItem(ACCESS_TOKEN);
  return tokenFromLocalStorage ? tokenFromLocalStorage : state.accessToken;
};
